export class RefreshEditOptionsMessage { }

export class PreviewImageLoadedMessage { }
